import React from "react";

export const Pin = (): JSX.Element => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="true"
      preserveAspectRatio="xMidYMid meet"
      viewBox="0 0 14.5 14.5"
    >
      <path
        fillRule="evenodd"
        d="M1.167 5.833C1.167 2.625 3.792 0 7 0s5.833 2.625 5.833 5.833c0 4.317-5.308 7.934-5.483 8.05-.117.059-.233.117-.35.117-.117 0-.234-.058-.35-.117-.175-.116-5.484-3.733-5.484-8.05zm1.166 0c0 3.15 3.558 6.067 4.667 6.884 1.108-.817 4.666-3.734 4.666-6.884A4.68 4.68 0 007 1.167a4.68 4.68 0 00-4.667 4.666zM7 3.5a2.34 2.34 0 00-2.333 2.333A2.34 2.34 0 007 8.167a2.34 2.34 0 002.333-2.334A2.34 2.34 0 007 3.5zM5.833 5.833A1.17 1.17 0 007 7a1.17 1.17 0 001.166-1.167A1.17 1.17 0 007 4.667a1.17 1.17 0 00-1.167 1.166z"
        clipRule="evenodd"
      />
    </svg>
  );
};
